import * as Sentry from '@sentry/browser'

function sentrySetup(sentryDsn) {
  if (sentryDsn) Sentry.init({ dsn: sentryDsn })
}

const notifyError = message => {
  Sentry.captureException(message)
}

export { notifyError, sentrySetup }
